import React from 'react';
import {NavLink} from 'react-router-dom';
import PropTypes from 'prop-types';

import Box from 'components/Box';
import TextLink from 'components/TextLink';
import Text from 'components/Text';
import {Grid, GridItem} from 'components/Grid';

import BigNumber from './BigNumber';

function NumberGrid({
	data,
	size = '1/2',
	mSize = '1/2',
	lSize = '1/2',
	className,
}) {
	const numbers = data.map(({title, link, id, value}) => {
		if (!id) {
			id = `${title.split(' ').join('-')}-count`;
		}

		return (
			<GridItem
				key={id}
				as="li"
				size={size}
				mSize={mSize}
				lSize={lSize}
				aria-labelledby={id}
			>
				<BigNumber count={value} id={id}>
					{link ? (
						<TextLink as={NavLink} to={link}>
							{title || link}
						</TextLink>
					) : (
						<Text dimmed>{title}</Text>
					)}
				</BigNumber>
			</GridItem>
		);
	});

	return (
		<Box pt="s">
			<Grid hasBottomSpacing as="ul" className={className}>
				{numbers}
			</Grid>
		</Box>
	);
}

NumberGrid.propTypes = {
	data: PropTypes.arrayOf(
		PropTypes.shape({
			title: PropTypes.string.isRequired,
			value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
				.isRequired,
			link: PropTypes.string,
			id: PropTypes.string,
		})
	),
	size: PropTypes.string,
	mSize: PropTypes.string,
	lSize: PropTypes.string,
};

export default NumberGrid;
